import { useSelector } from "react-redux";

import Th from "@/components/Table/Th";
import { table_head } from "../maintainers.module.scss";

import { table_titles } from "./estatesparents.constants";

const EstatesParentsTableHead = ({ order, setOrder, orderType, setOrderType }) => {
	const { customer } = useSelector((state) => state.auth.user);

	return (
		<thead className={table_head}>
			<tr>
				{table_titles &&
					table_titles.map((title, i) => {
						if (i === 2) {
							title.name = customer.customer_screens.find((cs) => cs.screen_id === 51)
								? customer.customer_screens.find((cs) => cs.screen_id === 51)?.name
								: "Campos";

							if (!customer.use_estates_parents) {
								return null;
							}
						}

						if (!customer.use_estates_parents && ["# Hectárea", "Hora Apertura", "Hora Cierre"].includes(title.name)) {
							return null;
						}

						return (
							<Th
								key={i}
								item_name={title.name}
								item_size={title.size}
								item_order={title.order}
								order={order}
								setOrder={setOrder}
								orderType={orderType}
								setOrderType={setOrderType}
								item_class={title.class}
								only_admin={title.only_admin}
								border_color={"0.5px solid #7fb02f"}
							></Th>
						);
					})}
			</tr>
		</thead>
	);
};

export default EstatesParentsTableHead;
